import { memo } from 'react';
import styled from '@emotion/styled';

import type { Wws_Announcement } from '../../types/graphql';
import type { Font, ThemeProps } from '@emotion/react';
import InlineEditHandler from '../InlineEdit/InlineEditHandler/InlineEditHandler';
import { buildEditAnnouncementBannerContextMenuButtons } from '../InlineEdit/InlineEditMessageFactory';

interface Props {
  announcement?: Wws_Announcement | undefined;
  className?: string | undefined;
}

const Bar = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px 20px;
  width: 100%;
  border: 12px solid
    ${(props: ThemeProps): string => props.theme.colors.background};
  background-color: ${(props: ThemeProps): string =>
    props.theme.fonts.s6.color};

  @media (max-width: 768px) {
    border-left: none;
    border-right: none;
    padding: 26px 20px;

    border: 10px solid
      ${(props: ThemeProps): string => props.theme.colors.background};
  }
`;
const Message = styled('p')`
  margin: 0 auto;
  max-width: 700px;
  text-align: center;
  ${(props: ThemeProps): Font => props.theme.fonts.s6};
  color: ${(props: ThemeProps): string => props.theme.colors.background};
`;

function Announcement({ announcement, className }: Props) {
  if (!announcement || !announcement.show) {
    return null;
  }

  const { message } = announcement;

  return (
    <InlineEditHandler
      contextMenuButtons={buildEditAnnouncementBannerContextMenuButtons()}
      outlineOffset={-2}
    >
      <Bar className={className}>
        <Message>{message}</Message>
      </Bar>
    </InlineEditHandler>
  );
}

export default memo(Announcement);
